module.exports = __webpack_public_path__ + "static/welcome-bg_mobile-12ff8bd6bb265e6b3a446c5222c7335c.svg";